/**
 * The coarse roles `AuthorityGuard` and the nav config check against.
 *
 * These mirror what `UserSerializer.get_authority` sends: `user`, one
 * `org:<role>`, and `staff` for a Django staff account.
 *
 * **They hide, they do not protect.** Every endpoint re-derives the caller's
 * role server-side from their membership; this list only decides what the SPA
 * bothers rendering. A hand-edited token that added `org:admin` here would get
 * a navigation item and a 403 behind it.
 *
 * `STAFF` was called `ADMIN` until the organisation layer landed. It had to be
 * renamed: "admin" now means a company administrator, and leaving the two
 * sharing a name would have given every Django staff account the company-admin
 * navigation — which would have looked deliberate.
 */

export const USER = 'user'

/** Django `is_staff`. The operator areas, not an organisation role. */
export const STAFF = 'staff'

export const ORG_OWNER = 'org:owner'
export const ORG_ADMIN = 'org:admin'
export const ORG_MEMBER = 'org:member'

/** Anything an administrator may reach. An owner can do everything an admin can. */
export const ORG_ADMINS = [ORG_OWNER, ORG_ADMIN]
